/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import { useEffect, useState } from 'react';
import useWindowSize from './useWindowSize';

export enum Device {
	DESKTOP = 'desktop',
	MOBILE = 'mobile',
	TABLET = 'tablet',
}

const useDevice = () => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [device, setDevice] = useState<Device>(Device.DESKTOP);
	const { width, height } = useWindowSize();

	useEffect(() => {
		if (width < 600) {
			setDevice(Device.MOBILE);
		} else if (width < 900) {
			setDevice(Device.TABLET);
		} else {
			setDevice(Device.DESKTOP);
		}
		setIsLoading(false);
	}, [width, height]);

	return {
		device,
		isLoading,
		isMobile: device === Device.MOBILE,
		isTablet: device === Device.TABLET,
		isDesktop: device === Device.DESKTOP || device === Device.TABLET,
	};
};

export default useDevice;
